import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Button from "../../../atoms/Button";
import InputField from "../../../atoms/InputField";
import { UPDATE_ARCHIVO_PERMAMENTE, UPDATE_HIPOTECA, UPDATE_RENTA_ARCHIVOS } from "../../../../api/apiFiles";

const ArchivoEdit = ({ doc, refetch, onClose, idTable }) => {
    const { table } = useParams();

    const selectedTable = () => {
        switch (table) {
            case "archivo_permanente":
                return UPDATE_ARCHIVO_PERMAMENTE;
            case "hipoteca":
                return UPDATE_HIPOTECA;
            case "archivos_renta":
                return UPDATE_RENTA_ARCHIVOS;
            default:
                toast.error("No es posible actualizar");
                return null;
        }
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        const endpoint = selectedTable();
        if (!endpoint) return;

        const fileData = { [doc.tableName]: values[doc.tableName] };
        const textData = {};

        try {
            setSubmitting(true);
            await endpoint(idTable, fileData, textData);
            refetch();
            onClose();
            toast.success("Inmueble actualizado correctament");
        } catch (error) {
            toast.error("Error al actualizar el inmueble")
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = {
        [doc.tableName]: null
    };

    const validationSchema = Yup.object().shape({
        [doc.tableName]: Yup.mixed()
            .required("Archivo requerido")
            .test(
                "fileSize",
                "El archivo es demasiado grande",
                (value) => !value || value.size <= 5 * 1024 * 1024
            )
    });

    return (
        <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
        >
            {({ isSubmitting, setFieldValue }) => (
                <Form className="flex flex-col justify-center items-center gap-5">
                    <InputField
                        name={doc.tableName}
                        label={doc.name}
                        type="file"
                        onChange={(e) => {
                            const file = e.currentTarget.files?.[0] || null;
                            setFieldValue(doc.tableName, file);
                        }}
                    />
                    <Button
                        text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar documento"} type="submit" bgColor="blue" disabled={isSubmitting}
                    />
                </Form>
            )}
        </Formik>
    );
};

export default ArchivoEdit;